export const analytics = () => {
  return {
    restrict: 'A',
    scope: {},
    bindToController: {_serviceItem: '=serviceItem', _service: '@service', _currency: '@currency'},
    controller: 'analyticsServiceController',
    controllerAs: 'analyticsServiceController'
  };
};